import { logger } from "@/utils/logger"
import { getId, getInstallations } from "firebase/installations"

let deviceId: string | null = null

export async function getDeviceId() {
   if (deviceId) return deviceId

   const installations = getInstallations()
   deviceId = await getId(installations)
   return deviceId
}

getDeviceId().then((id) => {
   logger("Device ID =", id)
})
